import { render, staticRenderFns } from "./prioritaet-widget.vue?vue&type=template&id=5a8f8843"
import script from "./prioritaet-widget.vue?vue&type=script&lang=js"
export * from "./prioritaet-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports